import { ref, watch } from 'vue';

/*
    Code which handles whether the STARTDATE and ENDDATE fields should be visible
*/
export function useDate(
    categoriesStore,
    queryParams,
) {

    function isEventCategory(id) {

        const topCats = categoriesStore.topLevelCategories;
        const cats = categoriesStore.categories;

        for (let i = 0; i < topCats.length; i++) {

            if (parseInt(topCats[i].id) === parseInt(id) && topCats[i].isEventCategory) {

                return true;

            }

        }

        for (let j = 0; j < cats.length; j++) {

            if (parseInt(cats[j].id) === parseInt(id) && cats[j].isEventCategory) {

                return true;

            }

        }

        return false;

    }

    const showDateField = ref(false);

    /*
        every time the query params change (because a new category has been
        checked / unchecked):
            1. if the new chosen top level category has the title of 'Events'...
            2. ...update showDateField to true
            3. else...
            4. ...update showDateField to false
    */
    watch(queryParams, () => {

        const queriedCats = queryParams.params.categories;

        for (let i = 0; i < queriedCats.length; i++) {

            if (isEventCategory(queriedCats[i])) {

                showDateField.value = true;

                return;

            }

        }

        showDateField.value = false;

        return;
            
    });

    return { 
        showDateField,
    };

}
